module.exports = __webpack_public_path__ + "static/img/zaefi.d713cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/logo/zaefi.png
// module id = mTAu
// module chunks = 34